export default __webpack_public_path__ + "static/media/3.6e5b8f69.png";